// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectQosDegradationQueryResult, selectQosDegradationsPageLoading, selectQosDegradationsShowInitWaitingMessage} from '../_selectors/qos-degradation.selectors';

export class QosDegradationsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectQosDegradationsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectQosDegradationsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectQosDegradationQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
